import { Button, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { nanoid } from "nanoid";
import { useFormikContext } from "formik";
import {
  lineEnum,
  newTypeEnum,
  paymentTypeEnum,
  productCategoryEnum,
  serviceTypeEnum,
} from "../../../../utils/enum";
import Swal from "sweetalert2";

const OrderLineAdd = ({ selectedLine, setSelectedLine }: any) => {
  const { values, errors, setFieldValue, isValid, resetForm }: any =
    useFormikContext();
  const addHandler = () => {
    if (values.categoryId && values.campaign) {
      let newLine: any = {
        id: nanoid(),
        address: `${values?.fullAddress} `,
        internetInfrustructure: values.internetInfrustructure,
        categoryName: values.categoryName,
        categoryId: values.categoryId,
        campaignId: values.campaign,
        campaignName: values.campaignName,
        paymentType:
          values.paymentType === paymentTypeEnum.new ? "Yeni" : "Churn",
        paymentTypeId: values.paymentType,
        customerManagementGroupIds: values.customerManagementGroupIds,
        ddtechType: values.ddtechType,
        ddtechTypeId: values.ddtechType,
      };

      let newType: any;
      if (values.categoryId === productCategoryEnum.connectService) {
        if (values.paymentType === paymentTypeEnum.new) {
          if (values.newType === newTypeEnum.lean_internet) {
            newType = "Yalın İnternet";
          } else if (values.newType === newTypeEnum.lean_internet_fiber) {
            newType = "Yalın İnternet Fiber";
          } else if (values.newType === newTypeEnum.internet) {
            newType = "İnternet";
          } else if (values.newType === newTypeEnum.inter_fttx) {
            newType = "İnternet Fttx";
          }
          newLine.newType = newType;
          newLine.newTypeId = values.newType;
          newLine.lineId = values.hatType;
          if (
            values.newType === newTypeEnum.lean_internet ||
            values.newType === newTypeEnum.lean_internet_fiber
          ) {
            newLine.internetAddress = values.internetAddresses;
          }
          if (
            values.newType === newTypeEnum.internet ||
            values.newType === newTypeEnum.inter_fttx
          ) {
            newLine.phoneNumber = values.phoneInternet;
          }
        } else {
          if (values.hatType === lineEnum.fixed_line) {
            newLine.lineType = "Sabit Hat";
            newLine.phoneNumber = values.servicePhone;
            newLine.circuitNumber = values.devreNo;
          } else {
            newLine.lineType = "Yalın Hat";
            newLine.circuitNumber = values.devreNo;
          }
        }
      }

      if (values.categoryId === productCategoryEnum.voiceService) {
        newLine.productName = values.productName;
        newLine.productTypeId = values.productTypeId;
        if (
          values.paymentType === paymentTypeEnum.churn ||
          values.paymentType === paymentTypeEnum.new
        ) {
          newLine.serviceTypeId = values.serviceType;
          if (values.serviceType === serviceTypeEnum.pstn) {
            newLine.serviceType = "PSTN";

            newLine.pstn = values.pstnPhoneNumbers;
          } else if (values.serviceType === serviceTypeEnum.bri) {
            newLine.serviceType = "BRI";
            newLine.bri = values.bri;
          } else if (values.serviceType === serviceTypeEnum.pri) {
            newLine.serviceType = "PRI";
            newLine.pri = values.pri;
          }
        }
      }

      setFieldValue("orderLines", [...values.orderLines, newLine]);
      setFieldValue("categoryId", "");
      setFieldValue("productTypeId", "");
      setFieldValue("campaign", "");
      setFieldValue("customerManagementGroupIds", []);
      setFieldValue("ddtechType", null);
      setFieldValue("pstnPhoneNumbers", [{ phone: "" }]);
      setFieldValue("pri", [{ phone: "", block: "", didcount: "" }]);
      setFieldValue("bri", [{ phone: "", block: "", didcount: "" }]);
      setFieldValue("internetAddresses", []);
      setFieldValue("internetInfrustructure", []);
      setFieldValue("devreNo", null);
      setFieldValue("servicePhone", null);
    } else {
      Swal.fire(
        "Uyarı!",
        "Sipariş Kalemi eklemeniz için tüm alanları doldurunuz.",
        "warning"
      );
    }
  };
  const editHandler = () => {
    let newLine: any = {
      categoryName: values.categoryName,
      categoryId: values.categoryId,
      campaignId: values.campaign,
      campaignName: values.campaignName,
      paymentType:
        values.paymentType === paymentTypeEnum.new ? "Yeni" : "Churn",
      paymentTypeId: values.paymentType,
      customerManagementGroupIds: values.customerManagementGroupIds,
      ddtechType: values.ddtechType,
      ddtechTypeId: values.ddtechType,
    };
    const filteredLines: any[] = values.orderLines.filter(
      (line: any) => line.id !== selectedLine.id
    );
    newLine.id = selectedLine.id;

    let newType: any;
    if (values.categoryId === productCategoryEnum.connectService) {
      if (values.paymentType === paymentTypeEnum.new) {
        if (values.newType === newTypeEnum.lean_internet) {
          newType = "Yalın İnternet";
        } else if (values.newType === newTypeEnum.lean_internet_fiber) {
          newType = "Yalın İnternet Fiber";
        } else if (values.newType === newTypeEnum.internet) {
          newType = "İnternet";
        } else if (values.newType === newTypeEnum.inter_fttx) {
          newType = "İnternet Fttx";
        }
        newLine.newType = newType;
        newLine.newTypeId = values.newType;
        newLine.lineId = values.hatType;
        if (
          values.newType === newTypeEnum.lean_internet ||
          values.newType === newTypeEnum.lean_internet_fiber
        ) {
          newLine.internetAddress = values.internetAddresses;
        }
        if (
          values.newType === newTypeEnum.internet ||
          values.newType === newTypeEnum.inter_fttx
        ) {
          newLine.phoneNumber = values.phoneInternet;
        }
      } else {
        if (values.hatType === lineEnum.fixed_line) {
          newLine.lineType = "Sabit Hat";
          newLine.phoneNumber = values.servicePhone;
          newLine.circuitNumber = values.devreNo;
        } else {
          newLine.lineType = "Yalın Hat";
          newLine.circuitNumber = values.devreNo;
        }
      }
    }
    if (values.categoryId === productCategoryEnum.voiceService) {
      newLine.productName = values.productName;
      newLine.productTypeId = values.productTypeId;
      if (
        values.paymentType === paymentTypeEnum.churn ||
        values.paymentType === paymentTypeEnum.new
      ) {
        newLine.serviceTypeId = values.serviceType;
        if (values.serviceType === serviceTypeEnum.pstn) {
          newLine.serviceType = "PSTN";

          newLine.pstn = values.pstnPhoneNumbers;
        } else if (values.serviceType === serviceTypeEnum.bri) {
          newLine.serviceType = "BRI";
          newLine.bri = values.bri;
        } else if (values.serviceType === serviceTypeEnum.pri) {
          newLine.serviceType = "PRI";
          newLine.pri = values.pri;
        }
      }
    }

    setFieldValue("orderLines", [...values.orderLines, newLine]);

    const selectedLineIndex: number = values.orderLines.findIndex(
      (line: any) => line.id === selectedLine.id
    );

    filteredLines.splice(selectedLineIndex, 0, newLine);
    setFieldValue("orderLines", filteredLines, true); /* */
    setFieldValue("categoryId", "");
    setFieldValue("productTypeId", "");
    setFieldValue("campaign", "");
    setFieldValue("customerManagementGroupIds", []);
    setFieldValue("ddtechType", null);
    setFieldValue("pstnPhoneNumbers", [{ phone: "" }]);
    setFieldValue("pri", [{ phone: "", block: "", didcount: "" }]);
    setFieldValue("bri", [{ phone: "", block: "", didcount: "" }]);
    setFieldValue("internetAddresses", []);
    setFieldValue("internetInfrustructure", []);
    setFieldValue("address", []);
    setFieldValue("devreNo", null);
    setFieldValue("servicePhone", null);
    setSelectedLine(null);
  };
  return (
    <Grid item md={12} style={{ marginTop: "30px" }}>
      <Grid container justifyContent="center" spacing={3}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon style={{ color: "white" }} />}
          onClick={addHandler}
          style={{ marginLeft: "10px", marginRight: "10px", height: "50px" }}
        >
          Sipariş Ekle
        </Button>
        {selectedLine ? (
          <Button
            variant="contained"
            color="secondary"
            startIcon={
              <DriveFileRenameOutlineIcon style={{ color: "white" }} />
            }
            onClick={editHandler}
            style={{ marginLeft: "10px", marginRight: "10px" }}
          >
            Sipariş Düzenle
          </Button>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default OrderLineAdd;
